<div [formGroup]="templateForm" *ngIf="templateForm">
    <p-confirmDialog header="Delete Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
    <p-toast></p-toast>
    <div>
        Name
        <input pInputText formControlName="name">
        Language: {{selectedTemplate.language.name}}
    </div>
    <div>
        Subject:
    </div>
    <div>
        <input pInputText formControlName="subject" class="subject-input">
    </div>
    <ckeditor [editor]="Editor" formControlName="body"></ckeditor>
    <p-button label="Submit" (onClick)="updateTemplate()" [disabled]="processing"></p-button>
    <p-button (onClick)="deleteTemplate()" label="Delete" styleClass="p-button-danger"></p-button>
</div>